// src/shared/hooks/use-object-url.ts
import { useState, useEffect } from 'react'
import { getFileFromFolder } from './utils'

export const useObjectUrl = (filePath: string | null) => {
	const [objectUrl, setObjectUrl] = useState<string | null>(null)
	const [isLoading, setIsLoading] = useState(false)
	const [error] = useState<string | null>(null)

	useEffect(() => {
		if (!filePath) {
			setObjectUrl(null)
			return
		}

		const generateUrl = async () => {
			setIsLoading(true)

			try {
				const file = await getFileFromFolder(filePath)
				const url = URL.createObjectURL(file)
				setObjectUrl(url)
			} catch (error) {
				// ... обработка ошибок ...
			} finally {
				setIsLoading(false)
			}
		}

		generateUrl()

		return () => {
			if (objectUrl) URL.revokeObjectURL(objectUrl)
		}
	}, [filePath])

	return { objectUrl, isLoading, error }
}
